<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <!-- <div class="modal-header">
            <slot name="header">
              default header
            </slot> -->
          <!-- <div
              class="close-x"
              @click="close"
              @mouseover="closeSize = 14"
              @mouseleave="closeSize = 12"
            >
              <IconClose
                :iconName="'Luk'"
                :color="'#FFFFFF'"
                :width="closeSize"
                :height="closeSize"
              />
            </div> -->
          <!-- </div> -->
          <div
            class="close-x"
            @click="close"
            @mouseover="closeSize = 14"
            @mouseleave="closeSize = 12"
          >
            <IconClose
              :iconName="'Luk'"
              :color="'#ADB1CE'"
              :width="closeSize"
              :height="closeSize"
            />
          </div>
          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import IconClose from '@/components/Icons/Close.vue';
export default {
  name: 'modal',
  components: {
    IconClose,
  },
  data() {
    return {
      closeSize: 12,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 650px;
  min-height: 250px;
  max-height: 80vh;
  margin: 0px auto;
  padding: 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-body {
  /* margin: 40px; */
  flex: 1;
  margin-top: -40px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  overflow: auto;
}

.modal-container input {
  font-size: 18px;
  font-weight: 600;
  height: 30px;
}

.close-x {
  align-self: flex-end;
  margin: 20px;
  cursor: pointer;
}
.close-x:hover {
  margin: 22px 19px 20 20;
}

@media only screen and (max-width: $mobile-max-width) {
  .modal-container {
    width: 90vw;
  }
}
</style>
